module.exports = __webpack_public_path__ + "static/media/Lens-Accent Style.10270c64.png";